<!--工作室简介-->
<template>
    <div class="studio_nav_content">
        <div class="left-container">
            <div class="nav-container">
                <div class="nav-title">
                    公告资讯
                </div>
                <div class="nav-list">
                    <div class="is-active">>公告</div>
                    <div class="">>资讯</div>
                </div>
            </div>
        </div>
        <div class="right-container">

        </div>
    </div>
</template>

<script>
export default {
    name:'noticeNews',
    components:{},
    props:{
        studioId:{
            type: String,
            default:null
        },
    },
    watch:{},
    mounted() {},
    data() {
        return {}
    },
    methods: {

    }
}

</script>

<style scoped>
.studio_nav_content{
    display: flex;
    width: 100%;
    height: auto;
}
.left-container{
    width: 200px;
    height: 200px;
    padding-bottom: 20px;
    box-sizing: border-box;
}
.nav-container{
    width: 180px;
    height: 100px;
    background: #fff;
}
.nav-title{
    width: 100%;
    height: 32px;
    background-color: #3b62f8;
    color: #fff;
    line-height: 32px;
    text-align: center;
    font-size: 16px;
    margin-bottom: 10px;
}

.nav-list{
    width: 180px;
    height: 100px;
    background: #fff;
    div{
        width: 100%;
        height: 24px;
        line-height: 24px;
        color: #333333;
        font-size: 15px;
        text-align: center;
        cursor: pointer;
    }
}
.is-active{
    color: #3b62f8!important;
    font-weight: bold;
}
.right-container{
    width: calc(100% - 200px);
    height: 200px;
}

</style>